import { render, staticRenderFns } from "./QuickActionItem.vue?vue&type=template&id=c21a3524&scoped=true"
import script from "./QuickActionItem.vue?vue&type=script&lang=ts"
export * from "./QuickActionItem.vue?vue&type=script&lang=ts"
import style0 from "./QuickActionItem.vue?vue&type=style&index=0&id=c21a3524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21a3524",
  null
  
)

export default component.exports